import { Store } from 'redux';

import { MainStoreState } from 'modules/main/store/MainStoreState';

import { onSsrClientUserEnvironmentLoaded } from './onSsrClientUserEnvironmentLoaded';
import { ssrClientGetPreloadedUserEnvironment } from './ssrClientGetPreloadedUserEnvironment';
import { ssrClientPerformanceMark } from './ssrClientPerformanceMark';
import { ssrClientWaitForUserEnvironmentToLoad } from './ssrClientWaitForUserEnvironmentToLoad';

export async function ssrClientLoadUserEnvironment(
  store: Store<MainStoreState>,
) {
  ssrClientPerformanceMark('Before setting login state');

  const preloadedUserEnvironment = ssrClientGetPreloadedUserEnvironment(store);

  if (preloadedUserEnvironment) {
    onSsrClientUserEnvironmentLoaded({
      store,
      userEnvironment: preloadedUserEnvironment,
    });
  } else {
    const userEnvironment = await ssrClientWaitForUserEnvironmentToLoad();
    onSsrClientUserEnvironmentLoaded({ store, userEnvironment });
  }
}
